import { DateRangePicker } from '~/@mid_ui-form/daterange-picker/DaterangePicker'

type Props = {
  startDate: Date
  endDate: Date
  onValueChange: (startDate: Date, endDate: Date) => void
}

function TransactionDateRangeFilter({
  startDate,
  endDate,
  onValueChange,
}: Props) {
  return (
    <DateRangePicker
      initialDateFrom={startDate}
      initialDateTo={endDate}
      onUpdate={(values) => {
        onValueChange(values.range.from, values.range.to ?? new Date())
      }}
    />
  )
}

export { TransactionDateRangeFilter }
